import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { ColorPicker } from "primereact/colorpicker";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

// SERVICE
import { pCtGisProgressColorUpdate } from "../../../service/400/P420Service";

export default function P413({ dialog, setDialog }) {
    const [errData, setErrData] = useState(null);
    const [formObject, setformObject] = useState({ percentMin: "", percentMax: "", colorValue: "" });
    const [loading, setLoading] = useState(false);
    const [color, setColor] = useState("1976D2");

    // DIALOG
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    useEffect(() => {
        if (dialog.open === true) {
            setformObject({ ...formObject, ...dialog.dataSet, userId: dialog.userId });
        }
    }, []);

    useEffect(() => {
        setColor(setViewForm("colorValue"));
    }, [formObject]);

    const setViewForm = (key) => {
        return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    // const setValueForm = (key, val) => {
    //     setformObject({ ...formObject, [key]: val });
    // };

    const handlerCloseDialog = () => {
        setDialog({ ...dialog, open: false, action: "", dataSet: null });
    };
    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const submitForm = () => {
        const req = {
            colorSeq: setViewForm("colorSeq"),
            colorValue: color,
            userId: setViewForm("userId"),
        };
        console.log(req);
        pCtGisProgressColorUpdate(req).then(
            (res) => {
                setLoading(false);
                handlerSettingDialogConfirm("", res[0].statusText);
                // handlerSettingDialogConfirm("", res[0].statusCode === "C" ? "บันทึกสมบูรณ์" : "มีข้อผิดพลาด");
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onHide = () => {
        handlerCloseDialog();
        setformObject({});
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            submitForm();
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm()} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
            </div>
        );
    };

    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />

            <Dialog header="เส้นทาง" visible={dialog.open} style={{ width: "25vw" }} footer={renderFooter()} onHide={() => onHide()} blockScroll={true} className="p-fluid" maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>เปอร์เซ็นต์จาก</label>
                        <InputText id="contractNo" value={setViewForm("percentMin")} maxLength={20} disabled={true} />
                    </div>
                    <div className="p-col-12">
                        <label>เปอร์เซ็นต์ถึง</label>
                        <InputText id="pipeLength" value={setViewForm("percentMax")} disabled={true} />
                    </div>

                    <div className="p-col-6">
                        <label>
                            เฉดสี<span style={{ color: "red" }}>*</span>
                        </label>
                        <br />
                        <ColorPicker value={color} onChange={(e) => setColor(e.value)} inline></ColorPicker>
                    </div>
                    <div className="p-col-6">
                        <br />
                        {/* <div style={{ display: 'flex' }}>
                            <InputText value={color} style={{ marginLeft: '20px' }}/>
                        </div> */}
                        <div className="p-inputgroup" style={{ marginLeft: '10px', width: '161px' }}>
                            <span className="p-inputgroup-addon">#</span>
                            <InputText value={color} onChange={(e) => setColor(e.target.value)} />
                        </div>
                        <div style={{ height: '128px', backgroundColor: "#" + color, border: '1px solid', marginLeft: '10px' }}></div>
                    </div>
                </div>
            </Dialog>
            <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="ยืนยันเพื่อลบรายการ หรือกดยกเลิกเพื่อยกเลิกการทำรายการ" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
